import React, { useState } from 'react';
import './payment.css';
import { useLocation } from 'react-router-dom';
import logo from "../../../assets/images/logo.png";

function Payment() {
    const { state } = useLocation();
    const htmlForm = state?.form;

    if (!htmlForm) {
        return (
            <div className="payment-page">
                <h2>Loading...</h2>
            </div>
        );
    }

    return (
        <div className="payment-page">
            {/* NAVBAR ================================================================= */}
            <div className="payment-nav">  
                <div className="payment-logo">
                    <img alt='Hymus Sports Logo' className="payment-logo-img" src={logo} />
                </div>
            </div>

            {/* PAYMENT FORM ========================================================= */}
            <div className="payment-container">
                <iframe
                    title="Hosted Payment"
                    name="paymentiFrame"
                    sandbox="allow-forms allow-scripts allow-same-origin allow-top-navigation"
                    srcDoc={htmlForm}
                    className="payment-iframe"
                />
            </div>
        </div>
    );
}

export default Payment;